import React, { useEffect, useState } from "react";
import LeagueTableRow from "./LeagueTableRow";
import NoDataFound from "../../common/NoDataFound";
import { loadStyles } from "../../../utils/cssLoader";
const StandingTable = ({
  data,
  loadCSS,
  dataClient = false,
  title,
  Groupdata = false,
}) => {
  const stats = [
    { symbol: "P", fullForm: "Played" },
    { symbol: "W", fullForm: "Wins" },
    { symbol: "D", fullForm: "Draws" },
    { symbol: "L", fullForm: "Losses" },
    { symbol: "GF", fullForm: "Goals For" },
    { symbol: "GA", fullForm: "Goals Against" },
    { symbol: "GD", fullForm: "Goal Difference" },
    { symbol: "PTS", fullForm: "Points" },
  ];
  const [clientData, setClientData] = useState(null);
  useEffect(() => {
    if (!dataClient) return;

    const container = document.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);
  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leaguestandings");
    }
  }, [loadCSS]);
  const sourceData = dataClient ? clientData?.football_tournament_tables : data;

  return (
    <div className="global_table standing_table">
      {title && <h1>{title}</h1>}
      <table>
        {sourceData?.length ? (
          <>
            <thead>
              <tr>
                <th>#</th>
                <th>Team</th>
                <th>P</th>
                <th>W</th>
                <th>D</th>
                <th>L</th>
                <th>F</th>
                <th>A</th>
                <th>GD</th>
                <th>PTS</th>
              </tr>
            </thead>
            <tbody>
              {sourceData
                ?.sort((a, b) => a?.plc - b?.plc)
                ?.map((t, i) => (
                  <LeagueTableRow data={t} key={i} />
                ))}
            </tbody>
          </>
        ) : (
          <thead>
            <tr>
              <th>
                <NoDataFound />
              </th>
            </tr>
          </thead>
        )}
      </table>
      {Groupdata && (
        <div className="bottom_tr">
          <ul className="item_list">
            {stats.map((item, index) => (
              <li key={index}>
                <span className="symbol">{item.symbol}</span>
                <span className="full-form">{item.fullForm}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StandingTable;
